function openFeedback() {
  var m = document.getElementById('feedbackModal');
  if (m) { m.classList.add('active'); var ta = document.getElementById('feedbackText'); if (ta) { ta.value = ''; setTimeout(function(){ ta.focus(); }, 50); } }
}
function closeFeedback() {
  var m = document.getElementById('feedbackModal');
  if (m) m.classList.remove('active');
}
async function submitFeedback() {
  var ta = document.getElementById('feedbackText');
  var msg = (ta && ta.value || '').trim();
  if (!msg) { showNotification(window.t ? window.t('feedback.empty') : 'Write a message first.', 'warning'); return; }
  var payload = {
    message: msg,
    /* ⚠ `state` e declarat cu `let` în app-core.js, deci NU e proprietate pe
       `window` — `window.state` era mereu `undefined` și, cu el, întreaga
       expresie. Rezultat: feedback-ul ajungea fără nume și fără e-mail.
       (E-mailul e oricum rescris acum de triggerul de limitare, dar numele nu.)
       EN: `state` is a `let` binding, not a property of `window`. */
    user_email: (typeof state !== 'undefined' && state.currentUser && state.currentUser.email) || null,
    user_name: (typeof state !== 'undefined' && state.currentUser && state.currentUser.name) || null,
    club_id: (typeof currentClubId !== 'undefined' && currentClubId) ? currentClubId : null,
    lang: (document.documentElement.lang || 'en'),
    url: location.href
  };
  try {
    var res = await sb.from('feedback').insert(payload);
    if (res && res.error) throw res.error;
    closeFeedback();
    showNotification(window.t ? window.t('feedback.sent') : 'Thanks! Feedback sent.', 'success');
  } catch (e) {
    console.warn('feedback insert', e);
    /* Serverul refuza prin `guard_feedback_rate` cu mesajul FEEDBACK_RATE_LIMIT
       (errcode 53400). Fara cazul asta, utilizatorul primea „nu s-a putut trimite"
       si incerca la nesfarsit, fara sa inteleaga de ce.
       EN: distinguish the server-side rate limit from a generic failure. */
    var _m = (e && (e.message || e.details || '')) + '';
    var _rate = _m.indexOf('FEEDBACK_RATE_LIMIT') !== -1 || (e && e.code === '53400');
    var _key = _rate ? 'feedback.rateLimit' : 'feedback.error';
    var _fb = _rate
      ? 'Ai trimis prea multe mesaje. Incearca din nou peste cateva minute.'
      : "Couldn't send the feedback.";
    showNotification(window.t ? window.t(_key) : _fb, _rate ? 'warning' : 'error');
  }
}
